import { FC } from 'react';
import { LoadingIndicator, Flex } from '@qga/roo-ui/components';

interface LoadingBlockProps {}

const LoadingBlock: FC<LoadingBlockProps> = () => (
  <Flex alignItems="center" justifyContent="center" minHeight="26rem" flexDirection="column" p={8} role="status" aria-label="Loading">
    <LoadingIndicator color="brand.primary" />
  </Flex>
);

export default LoadingBlock;
